module.exports = __webpack_public_path__ + "static/media/taxida_black.9060234f.svg";